import React from 'react';
import { useBoardStore } from '../../stores/boardStore';
import { Avatar } from '../common/Avatar';

export function ActivityFeed() {
  const { activity, board, selectCard } = useBoardStore();

  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diff = now.getTime() - date.getTime();

    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);

    if (minutes < 1) return 'just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;

    return date.toLocaleDateString();
  };

  const formatAction = (action: string, details: string | null, cardTitle: string | null) => {
    let parsedDetails: Record<string, string> = {};

    try {
      parsedDetails = details ? JSON.parse(details) : {};
    } catch {
      parsedDetails = {};
    }

    switch (action) {
      case 'created':
        return `created "${cardTitle || parsedDetails.title}"`;
      case 'moved':
        return `moved "${cardTitle}" to ${parsedDetails.to_column}`;
      case 'edited':
        return `edited "${cardTitle}"`;
      case 'commented':
        return `commented on "${cardTitle}"`;
      case 'tagged':
        return `tagged "${cardTitle}" with ${parsedDetails.tag_name}`;
      case 'deleted':
        return `deleted "${parsedDetails.title}"`;
      default:
        return `${action} "${cardTitle}"`;
    }
  };

  if (activity.length === 0) {
    return null;
  }

  const recentActivity = activity.slice(0, 3);

  return (
    <div className="border-t border-white/70 bg-white/72 px-4 py-4 backdrop-blur-xl sm:px-6">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.14em] text-slate-400">Recent Activity</div>
          <div className="mt-1 text-sm font-medium text-slate-700">
            {board?.name || 'Current board'}
          </div>
        </div>
        <div className="text-xs text-slate-500">
          Latest {recentActivity.length} updates
        </div>
      </div>

      <div className="mt-3 grid gap-3 lg:grid-cols-3">
        {recentActivity.map((item) => (
          <button
            key={item.id}
            onClick={() => item.card_id && selectCard(item.card_id)}
            className="flex items-start gap-3 rounded-2xl border border-slate-200/80 bg-white px-4 py-3 text-left shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md"
          >
            <Avatar
              name={item.user_name}
              color={item.user_avatar_color}
              size="sm"
            />
            <div className="min-w-0 flex-1">
              <div className="text-sm text-slate-600">
                <span className="font-semibold text-slate-800">
                  {item.user_name || 'Someone'}
                </span>{' '}
                {formatAction(item.action, item.details, item.card_title)}
              </div>
              <div className="mt-2 flex items-center gap-2 text-xs text-slate-400">
                <span>{formatTime(item.created_at)}</span>
                {item.card_id && (
                  <>
                    <span>•</span>
                    <span className="font-medium text-blue-600">Open card</span>
                  </>
                )}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
